import { ProductForm } from "@NextSkyTheme/add-to-cart";
import * as NextSkyTheme from "@NextSkyTheme/global";
import { notifier } from "@NextSkyTheme/notification";

class CartVariantForm extends ProductForm {
  constructor() {
    super();
    this.cart = this.closest("cart-drawer") || document.querySelector("main-cart") || document.querySelector("cart-drawer");
    this.select = this.querySelector("select[name=id]");
    this.status = this.querySelector("[role=status]");
    this.submitButton.removeAttribute("aria-haspopup");
    this.select?.addEventListener("change", () => this.updateVariant());
    this.updateVariant();
  }

  getSectionsToRender() {
    return this.cart?.getSectionsToRender() || [];
  }

  updateVariant() {
    const id = this.form.querySelector("[name=id]").value;
    const variant = this.querySelector(`template[data-variant="${id}"]`);
    if (!variant) return;
    this.querySelector("[data-variant-price]").replaceChildren(variant.content.cloneNode(true));
    this.querySelectorAll("[data-variant-link]").forEach((link) => { link.href = variant.dataset.url; });
    const image = this.querySelector(".cart-variant-card__image img");
    if (image && variant.dataset.image) {
      image.removeAttribute("srcset");
      image.src = variant.dataset.image;
      image.alt = `${this.dataset.productTitle}, ${variant.dataset.title}`;
    }
    this.form.querySelector("[name=quantity]").value = variant.dataset.quantity;
    this.submitButton.setAttribute("aria-label", `${this.dataset.addLabel}: ${this.dataset.productTitle}, ${variant.dataset.title}`);
    this.status.textContent = "";
  }

  async onSubmitHandler(event) {
    event.preventDefault();
    if (this.submitButton.disabled || this.busy) return;
    this.busy = true;
    this.submitButton.disabled = true;
    if (this.select) this.select.disabled = true;
    this.status.textContent = "";
    try {
      const body = new FormData(this.form);
      // Disabled selects are excluded from FormData. Keep the chosen variant explicit.
      body.set("id", this.form.querySelector("[name=id]").value);
      const sections = [...new Set(this.getSectionsToRender().map((section) => section.id))];
      if (sections.length) body.set("sections", sections.join(","));
      body.set("sections_url", window.location.pathname);
      const result = await fetch(window.routes.cart_add_url, {
        method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" }, body,
      });
      const response = await result.json();
      if (!result.ok || response.status) throw new Error(response.description || response.message || window.cartStrings.error);
      if (this.cart?.matches("main-cart")) {
        this.updateMainCart(response);
      } else if (this.cart) {
        this.cart.renderContents(response);
      }
      new NextSkyTheme.FSProgressBar("free-ship-progress-bar");
      NextSkyTheme.publish(NextSkyTheme.PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-variant-form", productVariantId: body.get("id"), cartData: response,
      });
      notifier.showElement(window.cartStrings.addSuccessMobile || this.dataset.addLabel, null, "success", 2500);
    } catch (error) {
      this.status.textContent = error.message || window.cartStrings.error;
      console.error("Cart recommendation could not be updated", error);
    } finally {
      this.busy = false;
      this.submitButton.disabled = false;
      if (this.select) this.select.disabled = false;
    }
  }
}

if (!customElements.get("cart-variant-form")) customElements.define("cart-variant-form", CartVariantForm);
